import { Tooltip, Typography } from '@mui/material';

interface Props {
  text: string;
  tooltip?: string;
}

const GenericTableText = ({ text, tooltip }: Props) => {
  return (
    <Tooltip title={tooltip} disableInteractive>
      <Typography variant="caption" color="text.secondary">
        {text}
      </Typography>
    </Tooltip>
  );
};

export default GenericTableText;
